// src/app/actions/reminders.js
// Interview Reminder Settings (admin) — fetch + save the single per-tenant doc.
// Mirrors actions/checklists.js (native fetch, Bearer token, { res } envelope).

// --- Action Types ---
export const FETCH_REMINDER_SETTINGS_REQUEST = 'FETCH_REMINDER_SETTINGS_REQUEST'
export const FETCH_REMINDER_SETTINGS_SUCCESS = 'FETCH_REMINDER_SETTINGS_SUCCESS'
export const FETCH_REMINDER_SETTINGS_FAILURE = 'FETCH_REMINDER_SETTINGS_FAILURE'

export const SAVE_REMINDER_SETTINGS_REQUEST = 'SAVE_REMINDER_SETTINGS_REQUEST'
export const SAVE_REMINDER_SETTINGS_SUCCESS = 'SAVE_REMINDER_SETTINGS_SUCCESS'
export const SAVE_REMINDER_SETTINGS_FAILURE = 'SAVE_REMINDER_SETTINGS_FAILURE'

// This endpoint isn't in the tenant config endpoints map, so we pass the full
// path — getApiUrl falls back to `${baseUrl}${endpoint}` for unknown keys.
const ENDPOINT = '/api/v1/interview-reminder-settings'

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('token')}`
})

// GET /api/v1/interview-reminder-settings
export const fetchReminderSettings = tenant => {
  return async dispatch => {
    dispatch({ type: FETCH_REMINDER_SETTINGS_REQUEST })
    try {
      const res = await fetch(tenant.getApiUrl(ENDPOINT), {
        method: 'GET',
        headers: authHeaders()
      })
      if (!res.ok) throw new Error('Failed to retrieve reminder settings')
      const data = await res.json()
      dispatch({
        type: FETCH_REMINDER_SETTINGS_SUCCESS,
        payload: (data.res && data.res.data) || null
      })
      return data.res && data.res.data
    } catch (err) {
      dispatch({ type: FETCH_REMINDER_SETTINGS_FAILURE, payload: err.message })
    }
  }
}

// PUT /api/v1/interview-reminder-settings
export const saveReminderSettings = (tenant, body) => {
  return async dispatch => {
    dispatch({ type: SAVE_REMINDER_SETTINGS_REQUEST })
    try {
      const res = await fetch(tenant.getApiUrl(ENDPOINT), {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify(body)
      })
      const data = await res.json()
      if (!res.ok || !(data.res && data.res.success)) {
        throw new Error(
          (data.res && data.res.message) || 'Failed to save reminder settings'
        )
      }
      dispatch({
        type: SAVE_REMINDER_SETTINGS_SUCCESS,
        payload: data.res.data
      })
      return data.res.data
    } catch (err) {
      dispatch({ type: SAVE_REMINDER_SETTINGS_FAILURE, payload: err.message })
      throw err
    }
  }
}
